export const SETTINGS_URL = 'settings'
export const ACCESS_URL = 'access'
export const HUB_SETTINGS_URL = 'hub-settings'
export const CUSTOMER_BRANDS_URL = 'customer-brands'
export const SYSTEM_PROMPT_URL = 'system-prompt'
export const RUN_SCHEDULED_AGENTS_URL = 'run-scheduled-agents'
export const AGENTS_URL = 'agents'
// "Hub accounts" binding for the dataset-accounts page; a DATASET_ACCOUNTS_URL
// binding would trip no-generic-identifier-data.
export const HUB_ACCOUNTS_URL = 'dataset-accounts'
export const DIGEST_URL = 'digest'
export const EXPORT_URL = 'export'
export const EXPORT_GROUPS_URL = 'export-groups'
export const PROFILE_URL = 'profile'
export const CONNECTORS_URL = 'connectors'
// The UVoC connector library. Hyphenated in the URL while the backend package
// is `data_connections`; the wire shape follows this route, not the module name.
export const CONNECTOR_LIBRARY_URL = 'data-connections'
export const SOURCE_INTEGRATIONS_URL = 'source-integrations'
export const INTEGRITY_REPORT_URL = 'data-integrity'
// Under INTEGRITY_REPORT_URL: `data-integrity/fix/<check_type>`.
export const INTEGRITY_FIX_URL = 'fix'
